import React from 'react'
import {Icon} from '@chakra-ui/react'

const CartIcon = (props) => {
    return (
        <Icon viewBox="0 0 20 21" data-testid="add-icon" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.60425 5.70679H17.3959V20.4985H2.60425V5.70679ZM4.06258 7.16512V19.0401H15.9376V7.16512H4.06258Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.9375 4.76929C5.9375 2.52563 7.75634 0.706787 10 0.706787C12.2437 0.706787 14.0625 2.52563 14.0625 4.76929V8.83179H12.6042V4.76929C12.6042 3.33105 11.4382 2.16512 10 2.16512C8.56176 2.16512 7.39583 3.33105 7.39583 4.76929V8.83179H5.9375V4.76929Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default CartIcon
